export const pageTitle = (title) => {
  return ( document.title = title ); // Unlock the Future: Airdrop Launch on Dec 25th, 2023 - Subscribe to Whitelist for the Launch Pad - ONLINE & OFFLINE
}